import { render, staticRenderFns } from "./VerifyResetPassword.vue?vue&type=template&id=89e3b2c4&scoped=true&"
import script from "./VerifyResetPassword.vue?vue&type=script&lang=js&"
export * from "./VerifyResetPassword.vue?vue&type=script&lang=js&"
import style0 from "./VerifyResetPassword.vue?vue&type=style&index=0&id=89e3b2c4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89e3b2c4",
  null
  
)

export default component.exports